import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { CampaignDashboardContainer } from '@/components/CampaignDashboard'

export function DashboardTab() {
  const [searchParams] = useSearchParams()

  const campaignId = useMemo(() => {
    const rawValue = searchParams.get('id')
    if (!rawValue) return null
    const parsed = Number(rawValue)
    return Number.isFinite(parsed) ? parsed : null
  }, [searchParams])

  return <CampaignDashboardContainer campaignId={campaignId} syncFiltersWithUrl />
}
